import auth from '../utils/auth';
import axios from 'axios';

export function getEntity(id, data) {
    return axios.request({
        url: `/entities/${id}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function saveEntity(id, data) {
    return axios.request({
        url: `/entities/${id}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: data
    });
}

export function deleteEntity(id) {
    return axios.request({
        url: `/entities/${id}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function getEntityGrids(id) {
    return axios.request({
        url: `/entities/${id}/grids`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}
